export default {
      id: "icon-logo-usage",
      viewBox: "0 0 102 58.427",
      url: __webpack_public_path__ + "img/icons.c8a27ec6.svg#icon-logo",
      toString: function () {
        return this.url;
      }
    }